import { Navigate, Route, Routes } from "react-router-dom";

import { NoAccess, SubNav } from "@/app/Shell";
import { GATE, useSession } from "@/auth/session";
import { ApiOverviewPage } from "@/modules/api/OverviewPage";
import { ApiActivityPage } from "@/modules/api/ActivityPage";
import { ApiConsolePage } from "@/modules/api/ConsolePage";
import { ApiReferencePage } from "@/modules/api/ReferencePage";

/** API module: Overview (auth model, conventions, quick start) + Reference
 *  (rendered LIVE from this deployment's /openapi.json — the docs cannot
 *  drift from the deployed API, because they ARE the deployed API).
 *
 *  TWO gates, not one. The module is GATE.API (1100). The **Activity** tab is
 *  additionally GATE.AUDIT (1600), because it is the only console surface onto
 *  the platform-wide audit trail: every actor, IP, action, status and error
 *  across every tenant. "May read the API docs" and "may see who called what"
 *  are different powers, and 1600 is what separates them. Its server route
 *  (/modules/audit/activity) is gated on 1600 independently, so hiding the tab
 *  is UX and `require_cap` is the enforcement. */
export function ApiModule() {
  const { can } = useSession();
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/api" tabs={[
          { path: "overview", label: "Overview" },
          { path: "reference", label: "Reference" },
          { path: "console", label: "Console" },
          { path: "activity", label: "Activity", gate: GATE.AUDIT },
        ]} />
      </div>
      <Routes>
        <Route path="overview" element={<ApiOverviewPage />} />
        <Route path="reference" element={<ApiReferencePage />} />
        <Route path="console" element={<ApiConsolePage />} />
        <Route path="activity" element={
          can(GATE.AUDIT) ? <ApiActivityPage /> : <NoAccess label="API activity" />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}
